"use strict";function t(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var e=t(require("styled-components")).default.section`
    display: grid;
    grid-row-gap: 20px;
    position: relative;

    picture {
        width: 100%;
        display: block;

        img {
            width: 100%;
            height: auto;
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
